module.exports = __webpack_public_path__ + "static/img/md-dj.580a52a7.png";